import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { requestSpeakerPromotion } from '../lib/api.js'
import { signOut } from '../lib/auth.js'
import { useAuthConfig } from '../config/appConfig.jsx'
import { PAGE_FORM } from '../lib/layout.js'
import { BTN_PRIMARY, BTN_SECONDARY } from '../lib/ui.js'

// #269 — what a logged-in VIEWER sees when they land on /admin or any
// other route that's gated to SPEAKER/ADMIN. Fires the
// request-speaker-promotion endpoint on mount; server is idempotent on the
// retry window so refreshing this view doesn't spam admins.
export default function NotASpeakerYet({ email, displayName }) {
  const authConfig = useAuthConfig()
  const [state, setState] = useState({ status: 'sending', error: null, newRequest: null })

  useEffect(() => {
    let cancelled = false
    requestSpeakerPromotion()
      .then((r) => {
        if (cancelled) return
        setState({ status: 'sent', error: null, newRequest: !!r.newRequest })
      })
      .catch((err) => {
        if (cancelled) return
        // Even on failure, the user-facing message stays optimistic — the
        // server retry-window means a refresh will try again. We surface the
        // error to console so jgp can diagnose, not to the user.
        console.error('[NotASpeakerYet] request-speaker-promotion failed:', err)
        setState({ status: 'sent', error: err.message || String(err), newRequest: null })
      })
    return () => { cancelled = true }
  }, [])

  const who = displayName || email || 'there'
  return (
    <main className={`${PAGE_FORM} pb-12 pt-12`}>
      <div className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200/60 sm:p-8">
        <h1 className="text-2xl font-bold tracking-tight text-slate-900">
          You're not a speaker yet
        </h1>
        <p className="mt-3 text-sm leading-6 text-slate-600">
          Hi {who} — your account is signed in, but the admin hasn't promoted
          you to a speaker yet. {state.status === 'sending'
            ? 'We’re notifying the team now…'
            : 'We’ve emailed the team to validate your account — you’ll get an email back when you’re approved.'}
        </p>

        {state.newRequest === false ? (
          <p className="mt-3 rounded-lg bg-slate-50 px-3 py-2 text-xs text-slate-600">
            A request from this account was already pending — no new email was
            sent this time, but we let the team know you came back.
          </p>
        ) : null}

        <div className="mt-6 flex flex-wrap gap-3">
          <Link
            to="/"
            className={BTN_PRIMARY}
          >
            Browse upcoming events
          </Link>
          <button
            type="button"
            onClick={() => signOut({ issuer: authConfig?.issuer })}
            className={BTN_SECONDARY}
          >
            Sign out
          </button>
        </div>
      </div>
    </main>
  )
}
